 
 
 
 
 
 
/**
 * This is an extension to Leaflet allowing to display TomTom traffic flow layer. It is based on  the raster L.TileLayer
 * implementation. The possible options are described below.
 *
 * @class TomTomTrafficFlowLayer
 * @extends L.TileLayer
 * @namespace L
 * @module Map
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-1.3.0.html#tilelayer-options">Leaflet's TileLayer</a>
 *     allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {"absolute"|"relative"|"relative-delay"} [options.style="absolute"] The traffic flow style to be displayed.
 *     It should be set to one of the following values:
 * - `"absolute"` makes the colours of the road segments reflect a measured absolute speed.
 * - `"relative"` returns a speed relative to the free-flow traffic information, highlighting areas of congestion.
 * - `"relative-delay"` displays relative speeds only in places where they are different from the free-flow speed
 *   (no green segments shown).
 * @param {Number} [options.opacity=0.7] The traffic flow layer's opacity, set by default to 70%.
 *     A floating point value between `0` and `1` have to be used, where `1` means no transparency.
 * @param {Boolean} [options.noRefresh] Disables periodic updates of traffic flow layer.
 * @param {Number} [options.refresh=180000] The traffic flow information changes and needs to be updated periodically.
 *     By default, it is refreshed every 3 minutes. This parameter's value represents the time in milliseconds between
 *     each update interval. The value must be 30000 or greater.
 */
/* jshint nomen:false */
define(['leaflet', 'security', 'http', 'endpoints', './animator', './optionsComplementor',
    './trafficRefresher', 'requester/analytics', './tileSetTransform', 'services/utils'],
function(L, security, http, endpoints, animator, optionsComplementor,
    trafficRefresher, analytics, tileSetTransform, Utils) {
    'use strict';

    var trafficFlowStyles = ['absolute', 'relative', 'relative-delay'];

    function getTrafficFlowStyle(trafficFlowLayer) {
        var style = 'absolute', i;
        if (Utils.isString(trafficFlowLayer)) {
            for (i = 0; i < trafficFlowStyles.length; i += 1) {
                if (trafficFlowStyles[i] === trafficFlowLayer.toLowerCase()) {
                    return trafficFlowStyles[i];
                }
            }
        }
        return style;
    }

    L.TomTomTrafficFlowLayer = L.TileLayer.extend({
        options: {
            attribution: '',
            minZoom: 2,
            maxZoom: 18,
            subdomains: 'abcd',
            reuseTiles: true,
            opacity: 0.7,
            style: 'absolute',
            refresh: 180000,
            errorTileUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAB9JREFUGBntwQENAAAAwiD7p34ON2AAAAAAAAAAAOcCIQAAAfWivQQAAAAASUVORK5CYII=', 
        name: 'trafficFlow',
        initialize: function(options) {
            var key;
            options = L.setOptions(this, options);
            if (options.bounds) {
                options.bounds = L.latLngBounds(options.bounds);
            }
            security.setKey('services/trafficFlow', options.key);
            key = security.getKey('services/trafficFlow');
            options.accessToken = key;
            this._url = http.protocol() + '://' + endpoints.trafficFlowLayer + (key ? '?key={accessToken}' : '');
            options.style = getTrafficFlowStyle(options.style);
            optionsComplementor.fillInSubdomainsOptions(options);
            optionsComplementor.fillInTiles512Options(options);
            this.setOpacity(options.opacity);

            tileSetTransform.fixTileScale.call(this);
        },
        onAdd: function(map) {
            L.TileLayer.prototype.onAdd.call(this, map);
            if (this._animated) {
                this.on('load', animator.loadAnimationFactory(this));
            }
            this._updateOpacity();
            this.trafficRefresherIntervalId = trafficRefresher.add(this.options, this.redraw.bind(this));
        },
        onRemove: function(map) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            L.TileLayer.prototype.onRemove.call(this, map);
        },
        updateOptions: function(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId = trafficRefresher.add(options, this.redraw.bind(this));
            L.setOptions(this, options);
        },
        createTile: function(coords, done) {
            return analytics.customCreateTile(coords, done, this);
        }
    });

    L.tomTomTrafficFlowLayer = function(options) {
        return new L.TomTomTrafficFlowLayer(options);
    };

    return L.tomTomTrafficFlowLayer;
});



// WEBPACK FOOTER //
// ./display/layers/trafficFlowLayer.js